<div *ngIf="isPageReady" id="printable-packing-slip" class="h-full flex">
  <div class="no-print p-2 grow flex flex-col border-2 shadow-lg" style="max-width: 8.5in; min-width: 8.5in">
    <div *ngIf="!invoice" #printableArea class="screen-p-20">
      <h2>Error: Voucher {{ invoiceId }} not found</h2>
    </div>
    <div *ngIf="invoice" #printableArea class="screen-p-20 grow" style="overflow: auto">
      <div class="flex flex-col mb-4">
        <div class="flex flex-row justify-between">
          <div>
            <h5>Packing Slip</h5>
          </div>
          <div>
            <h5>Unitec Distribution Systems</h5>
          </div>
        </div>

        <div class="flex flex-row justify-between">
          <div>
            <div class="mt-4" style="font-size: 16px; font-style: italic; font-weight: bold">
              Ship to:
            </div>
            <div class="mt-1" style="margin-left: -10px">
              <label for="shipping-address-textarea" class="sr-only">Shipping Address</label>
              <textarea id="shipping-address-textarea" style="border-style: none; width: 500px; height: 120px" pInputText rows="6"
                [ngModel]="getAddress(invoice.joHeader, 'shipping', true, true)" readonly="readonly"
                placeholder="Shipping Address" title="Shipping Address"></textarea>
            </div>
          </div>

          <div>
            <img src="{{qrurl}}" alt="{{recurl}}" height="160px" width="160px" />
          </div>
        </div>
      </div>

      <div class="grid grid-cols-4 gap-4">
        <div>{{ invoice.id }}</div>
        <div>{{ invoice.invoiceDate | date : "MM/dd/yyyy" }}</div>
        <div>{{ invoice.joHeader.customerPurchaseOrderNumber }}</div>
        <div>{{ invoice.joHeader.getFormalEmployeeName() }}</div>

        <div style="font-size: 14px; font-weight: bold; margin-top: -15px">
          Invoice Number
        </div>
        <div style="font-size: 14px; font-weight: bold; margin-top: -15px">
          Date
        </div>
        <div style="font-size: 14px; font-weight: bold; margin-top: -15px">
          Purchase Order
        </div>
        <div style="font-size: 14px; font-weight: bold; margin-top: -15px">
          Employee Name
        </div>
      </div>

      <div><p-divider /></div>

      <div class="mt-2">
        <table class="grid-print">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th colspan="2" class="col-center line-left line-right italic" style="font-style: italic">
                S H I P P E D
              </th>
              <th></th>
            </tr>
            <tr>
              <th class="col-left">Manufacturer</th>
              <th class="col-left">Config Name</th>
              <th class="col-left">Description</th>
              <th class="col-left">Features</th>
              <th class="col-right">New</th>
              <th class="col-right">Reissued</th>
              <th class="col-right">Back Ordered</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let d of details">
              <tr>
                <td>{{ d.joDetail.product.productType.manufacturer.name }}</td>
                <td>{{ d.joDetail.productTypeConfigName }}</td>
                <td>{{ d.joDetail.product.productType.description }}</td>
                <td>{{ d.joDetail.product.featureChoicesExtract }}</td>
                <td class="col-right">{{ d.shipQty }}</td>
                <td class="col-right">{{ d.redistributeQty }}</td>
                <!-- <td class="col-right">{{ d.joDetail.getUnshippedQty() }}</td> -->
                <td class="col-right">
                  {{ d.joDetail.getUnshippedAndUnvoucheredQty() }}
                </td>
              </tr>
              <tr *ngFor="let m of d.joDetail.joDetailAddons">
                <td></td>
                <td style="font-style: italic">
                  {{ m.addon.nameAndLocation }}
                </td>
                <td style="font-style: italic">{{ m.additionalInfo }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div><p-divider /></div>

      <div style="margin-top: -5px">
        <b>Please scan the QR code to confirm receipt of your order to your
          accounting department.</b>
      </div>

      <div class="mt-6">
        To access your personal Proximity account, please go to
        <b>www.UniformsByUnitec.com</b>. You may:
      </div>
      <div class="mt-4 ml-6">
        <ul style="list-style-type: disc">
          <li>... confirm that you received this order</li>
          <li>
            ... enter a discrepancy report if there is a problem with this
            shipment
          </li>
          <li>... check on the status of your orders</li>
          <li>... place additional orders on your Proximity account</li>
          <li>... check your allowance or issuance balances</li>
        </ul>
      </div>
    </div>

    <div uni-flex-row class="accent no-print mt-4">
      <div>
        <button pButton type="button" class="p-button-raised" [disabled]="!invoice" (click)="printDocument()">
          <span>Print</span>
        </button>
      </div>

      <div>
        <button pButton type="button" class="p-button-raised ml-2" icon="pi pi-arrow-left" (click)="goBack()">
          <span>Go Back</span>
        </button>
      </div>
    </div>
  </div>
</div>